<template>
  <div class="main">
    <div class="bg_pic1"></div>
    <div class="bg_pic2"></div>
    <div class="bg_pic3"></div>
    <div class="bg_pic4"></div>
    <div class="bg_pic5"></div>
    <div class="bg_pic6"></div>
    <div class="bg_pic7"></div>
    <div class="bg_pic8"></div>
    <div class="bg_pic9"></div>
    <div class="bg_pic10"></div>
    <div class="bg_pic11"></div>
    <div class="bg_pic12"></div>
    <div class="bg_pic13"></div>
    <div class="bg_pic14"></div>
    <div class="bg_pic15"></div>
    <div class="bg_pic16"></div>
    <div class="bg_pic17"></div>
    <div class="bg_pic18"></div>
    <div class="bg_pic19"></div>
    <div class="bg_pic20"></div>
    <div class="bg_pic21"></div>
    <div class="bg_pic22"></div>
    <div class="bg_pic23"></div>
    <div class="bg_pic24"></div>
    <div class="bg_pic25"></div>
    <div class="bg_pic26"></div>
    <div class="bg_pic27"></div>
    <div class="bg_pic28"></div>
    <div class="bg_pic29"></div>
<!--    <div class="bg_pic30"></div>-->
    <div class="m-foot">
      ©浙江吉利汽车备件有限公司 <a href="https://beian.miit.gov.cn">浙ICP备2025192899号-4</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home'
}
</script>

<style scoped lang="scss">
@import "./home.scss";
.m-foot{
  background: #f7f7f7;
  text-align: center;
  color: #999;
  font-size: 14px;
  padding-top: 5px;
  padding-bottom: 50px;
  a{
    color: #999;
    text-decoration: none;
  }
}
</style>
